import { useCallback } from "react";
import { authInstance } from "../utils";

export const useLogout = () => {
    return useCallback(() => {
        void authInstance.logout();
    }, []);
};
